// Jurisdiction-aware AI News coverage rules.
// Pure functions only: no storage, network, auth, or assessment mutation.

export function normalizeAuditJurisdiction(value) {
  const raw = String(value || "").trim().toUpperCase().replace(/\s+/g, "_");
  if (raw === "US" || raw === "US_(FED)" || raw === "US_FED" || raw === "US_(FEDERAL)") return "US_FED";
  if (raw === "US_(STATE)" || raw === "US_STATE") return "US_STATE";
  if (raw === "UK" || raw === "EU") return raw;
  return String(value || "").trim().toUpperCase();
}

export function buildNewsCoverage(payload) {
  const jurisdictions = new Set(
    (Array.isArray(payload?.jurisdictions) ? payload.jurisdictions : [])
      .map(normalizeAuditJurisdiction)
      .filter(Boolean)
  );
  const selectedStates = new Set(
    (Array.isArray(payload?.selectedStates) ? payload.selectedStates : [])
      .map((code) => String(code || "").trim().toUpperCase())
      .filter(Boolean)
  );
  const personalized = jurisdictions.size > 0;
  const stateSelectionIncomplete = jurisdictions.has("US_STATE") && selectedStates.size === 0;

  return {
    personalized,
    jurisdictions,
    selectedStates,
    stateSelectionIncomplete,
    fallbackFederalOnly: !personalized,
  };
}

export function matchesNewsCoverage(item, coverage) {
  const jurisdiction = String(item?.jurisdiction || "").trim().toUpperCase();
  const stateCode = String(item?.state_code || "").trim().toUpperCase();

  // Fail-closed fallback: without an authoritative active audit profile,
  // show only untagged U.S. Federal items. Never show state, UK, or EU items.
  if (!coverage?.personalized) {
    return jurisdiction === "US" && !stateCode;
  }

  if (jurisdiction === "US") {
    if (stateCode) {
      return coverage.jurisdictions.has("US_STATE") && coverage.selectedStates.has(stateCode);
    }
    if (coverage.jurisdictions.has("US_FED")) return true;
    // Defensive edge case: Start Audit normally prevents saving US_STATE without states.
    // If such a profile exists, fall back to Federal only rather than exposing all states.
    return Boolean(coverage.stateSelectionIncomplete);
  }

  if (jurisdiction === "UK") return coverage.jurisdictions.has("UK");
  if (jurisdiction === "EU") return coverage.jurisdictions.has("EU");
  return false;
}
